import React from 'react';
import { Container } from 'react-bootstrap';
import EmployeeAppraisalList from '../components/EmployeeAppraisalList';
import Layout from '../../../components/Layout';

const EmployeeAppraisalListPage = () => {
  return (
    <Layout>
      <EmployeeAppraisalList />
    </Layout>
  );
};

export default EmployeeAppraisalListPage;
